import { api } from "./axiosInstance";
import type { User } from "../types/domain.types";

export interface LoginResponse {
  accessToken: string;
  user: User;
}

export async function loginRequest(
  email: string,
  password: string,
): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>("/auth/login", {
    email,
    password,
  });
  return data;
}

export async function logoutRequest(): Promise<void> {
  await api.post("/auth/logout");
}
